import * as z from "zod/v4";
import { type UserResponse, zCurrentUser } from "../models/user";
import { ApiBase } from "./apiBase";

type AuthResponse = {
  user: UserResponse;
};

const zTokenResponse = z.object({
  user: zCurrentUser,
  validUntil: z.string().nullable(),
  username: z.string().nullable(),
});

type TokenResponse = z.infer<typeof zTokenResponse>;

class AuthApi extends ApiBase {
  async currentUser() {
    return this.get<TokenResponse>(
      "auth/validate_token",
      {},
      { schema: zTokenResponse },
    );
  }
  async login(username: string, password: string) {
    return this.post<AuthResponse>("auth/login", { username, password });
  }

  async logout() {
    return this.get("auth/logout");
  }

  async changePassword(
    oldPassword: string,
    newPassword: string,
    passwordConfirmation: string,
  ) {
    return this.post<UserResponse>("auth/update_password", {
      oldPassword,
      newPassword,
      passwordConfirmation,
    });
  }
}

export default new AuthApi();
